import { theme } from '@chakra-ui/pro-theme';
import { defineStyleConfig, extendTheme } from '@chakra-ui/react';
import 'react-data-grid/lib/styles.css';
import './theme_overrides.css';

const AutoCompleteItemBox = defineStyleConfig({
  baseStyle: ({ colorMode, theme }) => ({
    borderWidth: '2px',
    borderRadius: '2px',
    borderColor: 'gray.800'
  }),
  variants: {
    selected: ({ theme, colorMode }) => ({
      backgroundColor: colorMode === 'dark' ? 'blue.100' : 'blue.50',
      color: 'black',
    }),
    outline: ({ colorMode }) => ({
      borderColor: colorMode === 'dark' ? 'blue.200' : 'blue.50',
    })
  }
});

const Spinner = defineStyleConfig({
  baseStyle: ({ colorMode }) => ({
    thickness: '2.5px',
    colorScheme: colorMode === 'dark' ? 'black' : 'yellow.600'
  })
});

export const AppTheme = extendTheme(
  {
    components: {
      AutoCompleteItemBox,
      Spinner,
    },
    colors: { ...theme.colors, brand: theme.colors.blue },
  },
  theme
);

export const pickFirst = <T extends unknown>(def: T, ...conditions: [T, boolean][]) => {
  const first = conditions.find(c => c[1]);
  return first?.[0] || def;
}
